import { Dispatch, SetStateAction, useCallback } from 'react'

const useSelectNumber = (update: Dispatch<SetStateAction<number>>, setIsEdited?: Dispatch<SetStateAction<boolean>>) => {
  return useCallback(
    (value: string) => {
      update(parseInt(value, 10))
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useSelectNumber
